import { defineMessages } from 'react-intl';

type MessageKeys = 'dragDropMessage';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		dragDropMessage: {
			id: 'rovo-chat.file-upload-dropzone.drag-drop-message',
			defaultMessage: 'Drag and drop to add context',
			description: 'Message displayed in the file upload dropzone when no files are selected',
		},
	});

export default message;
